import { useEffect, useState } from "react";
import { supabase } from "./supabase";

/**
 * As NOVIDADES das ferramentas do aluno (000304 — o F4 do Plano de Melhorias).
 *
 * Uma atualização registrada pela equipe de Produtos pode ser DIVULGADA: ganha
 * um aviso curto, que aparece por 30 dias como «Novidade» no card da ferramenta,
 * na página do curso, e no alto da ferramenta.
 *
 * ZERO regra aqui. Quem decide QUAIS novidades o aluno vê — só das ferramentas
 * que ele tem, uma por ferramenta, enquanto valem — é `minhas_novidades()`, no
 * banco, pela vitrine. Falha de leitura vira lista vazia: a novidade é um
 * enfeite da tela, e a ferramenta não pode deixar de abrir por causa dela.
 */
export type Novidade = {
  card_slug: string;
  atualizacao_id: string;
  quando: string;
  texto: string;
  divulgada_em: string;
};

export async function lerMinhasNovidades(): Promise<Map<string, Novidade>> {
  const { data, error } = await supabase.rpc("minhas_novidades");
  if (error || !Array.isArray(data)) return new Map();
  return new Map((data as Novidade[]).map((n) => [n.card_slug, n]));
}

/** As novidades do aluno, por slug do card. Vazio enquanto carrega ou se falhar. */
export function useNovidades(): Map<string, Novidade> {
  const [novidades, setNovidades] = useState<Map<string, Novidade>>(() => new Map());
  useEffect(() => {
    let vivo = true;
    void lerMinhasNovidades().then((m) => {
      if (vivo) setNovidades(m);
    });
    return () => {
      vivo = false;
    };
  }, []);
  return novidades;
}

/**
 * "Já vi esta novidade" — conveniência de quem vê, e por isso no
 * `localStorage`: fechar o aviso no alto da ferramenta não precisa sobreviver a
 * outro aparelho, e o selo no card continua lá pelos 30 dias. Toda leitura e
 * escrita vai em `try`: em janela anônima ou com o armazenamento bloqueado, o
 * aviso simplesmente volta a aparecer.
 */
const CHAVE = (id: string) => `cf-novidade-vista:${id}`;

export function novidadeJaVista(id: string): boolean {
  try {
    return window.localStorage.getItem(CHAVE(id)) === "1";
  } catch {
    return false;
  }
}

export function marcarNovidadeVista(id: string): void {
  try {
    window.localStorage.setItem(CHAVE(id), "1");
  } catch {
    /* sem armazenamento, o aviso só volta na próxima visita */
  }
}
